import { MagnifyingGlass } from '@creditornot/cb-icons';
import { colors, cssThemedValue } from '@creditornot/cb-ingredients';
import { Input } from '@creditornot/cb-input';
import { ModalHeader } from '@creditornot/cb-modal';
import React, { ReactNode } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';

type ModalLayoutProps = {
  searchValue: string;
  children: ReactNode;
  setSearchValue(value: string): void;
  onClose(): void;
};

const SearchInput = styled(Input).attrs({ icon: <MagnifyingGlass /> })`
  margin-block-end: 8px;
`;

const SearchInputWrapper = styled.div`
  padding: 12px 16px;
  border-block-end: 1px solid ${cssThemedValue({ light: colors.pepper8, dark: colors.salt12 })};
`;

export const ModalLayout = ({ searchValue, children, setSearchValue, onClose }: ModalLayoutProps) => {
  const isReadonly = false;
  const { formatMessage } = useIntl();

  return (
    <>
      <ModalHeader onCloseClick={onClose}>
        <FormattedMessage
          id={isReadonly ? 'campaigns.form.venues.venues-title' : 'campaigns.form.venues.edit-venues'}
        />
      </ModalHeader>
      <SearchInputWrapper>
        <SearchInput
          onClearClick={() => setSearchValue('')}
          onChange={e => setSearchValue(e.target.value)}
          value={searchValue}
          placeholder={formatMessage({ id: 'campaigns.form.venues.search' })}
        />
      </SearchInputWrapper>
      {children}
    </>
  );
};
